"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const common_1 = require("../common");
exports.formatDate = (date, ...params) => {
    // @ts-ignore
    let formattingOptions = {};
    if (typeof date === 'number' || typeof date === 'string') {
        date = new Date(date);
    }
    if (params.length === 2) {
        formattingOptions = params.pop();
    }
    let locale = common_1.getWindowLocale();
    if (params.length === 1) {
        if (typeof params[0] === 'string') {
            locale = params[0].replace('_', '-');
        }
        else if (typeof params[0] === 'object') {
            formattingOptions = params[0];
        }
    }
    return date.toLocaleDateString(locale, formattingOptions);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9kYXRlcy9mb3JtYXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsc0NBQTRDO0FBRS9CLFFBQUEsVUFBVSxHQUFHLENBQ3RCLElBQTRCLEVBQzVCLEdBQUcsTUFBa0QsRUFDdkQsRUFBRTtJQUNBLGFBQWE7SUFDYixJQUFJLGlCQUFpQixHQUFHLEVBQUUsQ0FBQztJQUMzQixJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsSUFBSSxPQUFPLElBQUksS0FBSyxRQUFRLEVBQUU7UUFDdEQsSUFBSSxHQUFHLElBQUksSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ3pCO0lBRUQsSUFBSSxNQUFNLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtRQUNyQixpQkFBaUIsR0FBRyxNQUFNLENBQUMsR0FBRyxFQUFnQyxDQUFDO0tBQ2xFO0lBRUQsSUFBSSxNQUFNLEdBQUcsd0JBQWUsRUFBRSxDQUFDO0lBQy9CLElBQUksTUFBTSxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7UUFDckIsSUFBSSxPQUFPLE1BQU0sQ0FBQyxDQUFDLENBQUMsS0FBSyxRQUFRLEVBQUU7WUFDL0IsTUFBTSxHQUFHLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDO1NBQ3hDO2FBQU0sSUFBSSxPQUFPLE1BQU0sQ0FBQyxDQUFDLENBQUMsS0FBSyxRQUFRLEVBQUU7WUFDdEMsaUJBQWlCLEdBQUcsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO1NBQ2pDO0tBQ0o7SUFFRCxPQUFPLElBQUksQ0FBQyxrQkFBa0IsQ0FBQyxNQUFNLEVBQUUsaUJBQWlCLENBQUMsQ0FBQztBQUM5RCxDQUFDLENBQUMifQ==